import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import authReducer from "./slices/authSlice";
import orgReducer from "./slices/organizationSlice";
import teamReducer from "./slices/teamSlice";
import projectReducer from "./slices/projectSlice";
import clientReducer from "./slices/clientSlice";
import trackerReducer from "./slices/trackerSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    org: orgReducer,
    teams: teamReducer,
    projects: projectReducer,
    clients: clientReducer,
    tracker: trackerReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = useDispatch<AppDispatch>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
